import { cn } from '@repo/tailwind-config/tailwind.functions'
import ActionButton from '@repo/ui/action-button'
import Button from '@repo/ui/button'
import { DeleteIcon, PlusIcon } from '@repo/ui/icons'
import React, { useState } from 'react'

import { FriendInput } from '../../../../lib/types/models/friend/friend-input'
import ActionButtons from '../../../elements/action-buttons'
import FriendForm, { FriendFormRef } from '../../enrollments/enrollment-form/friend-form'

type Props = {
  defaultValues?: FriendInput[]
  className?: string
  onCancel: () => void
  onSubmit: (data: FriendInput[]) => Promise<void>
}

type FriendState = {
  input: Partial<FriendInput>
  ref: React.RefObject<FriendFormRef>
}

const FriendsForm = ({ defaultValues, className, onCancel, onSubmit }: Props) => {
  const [state, setState] = useState<FriendState[]>(
    defaultValues?.map((friend) => ({ input: friend, ref: React.createRef<FriendFormRef>() })) ??
      []
  )

  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async () => {
    // Trigger the validation of all the forms
    let isValid = true
    for (const friend of state) {
      const result = await friend.ref?.current?.submitForm()
      if (!result) isValid = false
    }
    if (!isValid) return
    setIsLoading(true)
    await onSubmit(state.map((friend) => friend.input as FriendInput))
    setIsLoading(false)
  }

  return (
    <div>
      <div className={cn(className, 'flex flex-col gap-3 items-start')}>
        {state.map((friendState, index) => (
          <div className="w-full p-3 border border-grey-light rounded relative" key={index}>
            <FriendForm
              containerClassName="w-full"
              ref={friendState.ref}
              variant="content-only"
              defaultValues={friendState.input}
              buttonsConfig={[]}
              onChange={(value) => {
                setState((prevState) => {
                  const newState = [...prevState]
                  newState[index] = { ...newState[index], input: value }
                  return newState
                })
              }}
            />
            <div className="absolute bottom-2 right-2">
              <ActionButton
                variant={'danger'}
                icon={DeleteIcon}
                onClick={() => {
                  setState((prevState) => {
                    const newState = [...prevState]
                    newState.splice(index, 1)
                    return newState
                  })
                }}
              />
            </div>
          </div>
        ))}

        <Button
          type="button"
          label="Ajouter un ami"
          variant="secondary"
          icon={PlusIcon}
          onClick={() =>
            setState([...state, { input: new Object(), ref: React.createRef<FriendFormRef>() }])
          }
        />
      </div>
      <ActionButtons
        variant="submit"
        isLoading={isLoading}
        onCancel={onCancel}
        onSubmit={handleSubmit}
      />
    </div>
  )
}

export default FriendsForm
